import styled from 'styled-components';
import { Switch } from 'antd';

export const StyledSwitch = styled(Switch)`
  &.secondary-color {
    &.ant-switch-checked {
      background-color: ${({ theme }) =>
        theme.palette.secondary.main} !important;

      &:hover {
        background-color: ${({ theme }) =>
          theme.palette.secondary.main} !important;
        opacity: 0.8;
      }

      &:focus {
        box-shadow: 0 0 0 2px ${({ theme }) => theme.palette.secondary.main}33 !important;
      }
    }

    &:hover:not(.ant-switch-disabled) {
      &:not(.ant-switch-checked) {
        background-color: rgba(0, 0, 0, 0.25);
      }
    }

    &:focus {
      outline: none;
    }
  }
`;
